import React, { useEffect, useState, useContext } from "react";
import {
  TextField,
  Button,
  Snackbar,
  Grid,
  Typography,
  Modal,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Alert } from "@mui/lab";
import axios from "axios";
import {
  DataGrid,
  GridActionsCellItem,
  GridDeleteIcon,
  GridToolbar,
  GridFilterPanel
} from "@mui/x-data-grid";
import AppContext from "../context/AppContext";
const AddCategoryForm = () => {

  const storedUserRole = localStorage.getItem('userRole');


  const [input, setInput] = useState({
    category_name: "",
    description: "",
    other: "",
    id: "",
  });
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const { category, setCategory, userRole } = useContext(AppContext);
  const [update, setUpdate] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/beacon/add/category`,
        {
          category_name: input.category_name,
          description: input.description,
          other: input.other,
        }
      );
      if (response.data.status == "success") {
        setInput({ ...input, category_name: "", description: "", other: "" });
        // setCategory([{...response.data.Category_details[0]}, ...category])
        setMessage(response.data.message);
        setSeverity("success");
        setOpen(true);
        setOpenModal(false);
      }
    } catch (error) {
      console.log(error);
      setMessage(error.response.data.error || "Failed to add category");
      setSeverity("error");
      setOpen(true);
    }
  };
  const handleSubmitUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/beacon/update/category`,
        {
          categoryname: input.category_name,
          description: input.description,
          otherattributes: input.other,
          category_id: input.id,
        }
      );
      if (response.data.status == "success") {
        setInput({ ...input, category_name: "", description: "", other: "" });
        setMessage(response.data.message);
        setSeverity("success");
        setOpen(true);
        setOpenModal(false);
      }
    } catch (error) {
      console.log(error);
      setMessage(error.response.data.error || "Failed to Update category");
      setSeverity("error");
      setOpen(true);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const categoryResponse = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/beacon/get/assets/categories`
        );
        if (categoryResponse.data.status === "success") {
          setCategory(categoryResponse.data.category);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [open]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleUpdate = (row) => {
    setUpdate(true);
    setInput({
      category_name: row.category_name,
      description: row.description,
      other: row.other_attributes,
      id: row.id,
    });

    setOpenModal(true);
  };

  const handleDelete = async (row) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/beacon/delete/category`,
        { category_id: row.id }
      );
      if (response.data.status == "success") {
        setInput({ ...input, category_name: "", description: "", other: "" });
        setMessage(response.data.message);
        setSeverity("success");
        setOpen(true);
        setOpenModal(false);
      }
    } catch (err) {
      console.log(err);
      setMessage(err.response.data.error || "Failed to Delete category");
      setSeverity("error");
      setOpen(true);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setInput({
      ...input,
      [name]: value,
    });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleOpenModal = async () => {
    setUpdate(false);
    setInput({
      category_name: "",
      description: "",
      other: "",
    });
    setOpenModal(true);
  };

  const columns = [
    {
      field: "id",
      headerName: "S.No",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL.No "}</strong>
      ),
      filterable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },

    {
      field: "category_name",
      headerName: "CATEGORY NAME",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"CATEGORY NAME "}
        </strong>
      ),
    },
    {
      field: "description",
      headerName: "DESCRIPTION",
      width: 300,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"DESCRIPTION "}</strong>
      ),
      renderCell: (params) => {
        return (
          <div>{params.row.description ? params.row.description : "NA"}</div>
        );
      },
    },
    {
      field: "other_attributes",
      headerName: "Other",
      width: 320,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"OTHER "}</strong>
      ),
      renderCell: (params) => (
        <div>
          {typeof params.row.other_attributes === "object"
            ? JSON.stringify(params.row.other_attributes)
            : params.row.other_attributes || "NA"}
        </div>
      ),
    },
    {
      field: "update",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}></strong>
      ),
      renderCell: (params) => (
        <Button
          variant="contained"
          style={{ borderRadius: 25, fontSize: 9, padding: 4, backgroundColor: storedUserRole == 'demo' ? 'grey' : '' }}
          onClick={() => storedUserRole == 'demo' ? '' : handleUpdate(params.row)}
        >
          Update
        </Button>
      ),
    },
    {
      field: "delete",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}></strong>
      ),
      renderCell: (params) => {
        if (userRole == "napino") {
          return null;
        }

        return (
          <Button
            variant="contained"
            style={{ borderRadius: 25, fontSize: 9, padding: 4, backgroundColor: storedUserRole == 'demo' ? 'grey' : '', cursor: storedUserRole == 'demo' ? 'text' : '' }}

            onClick={() => storedUserRole == 'demo' ? '' : handleDelete(params.row)}
          >
            Delete
          </Button>
        );
      },
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography
          style={{
            display: "flex",
            justifyContent: "flex-end",
            border: "none",
            backgroundColor: "transparent",
            cursor: "pointer",
            color: storedUserRole == 'demo' ? 'grey' : 'green',
            fontSize: 18,
          }}
          onClick={storedUserRole == 'demo' ? () => '' : handleOpenModal}
        >
          + Add Category
        </Typography>

        <DataGrid
          getRowId={(row) => row.id}
          rows={category}
          columns={columns}
          density="compact"
          rowSelection={false}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 30]}
          components={{
            Toolbar: GridToolbar,
            FilterPanel: GridFilterPanel,
          }}
          slotProps={{
            filterPanel: {
              sx: {
                width: "100%",          // full width responsive
                maxWidth: "100%",
                padding: "10px",
                "& .MuiDataGrid-filterForm": {
                  flexDirection: "column",
                  gap: "10px",
                },
              },
            },
          }}
          pagination
          style={{
            backgroundColor: 'white'
          }}
        />
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",

              width: isMobile ? 300 : 600,
              maxHeight: "100%",

              overflowY: "auto",
              overflowX: "auto",
              backgroundColor: "white",
              boxShadow: 24,
              padding: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "flex-end",
                cursor: "pointer",
              }}
              onClick={handleCloseModal}
            >
              <img style={{ width: 20, height: 20 }} src="/Close.png" />
            </div>
            <form
              onSubmit={update ? handleSubmitUpdate : handleSubmit}
              style={{ flexDirection: "column", display: "flex" }}
            >
              <TextField
                label="Category"
                name="category_name"
                value={input.category_name}
                onChange={(e) => handleInputChange(e)}
                margin="normal"
                required
              />
              <TextField
                label="Description"
                name="description"
                value={input.description}
                onChange={(e) => handleInputChange(e)}
                margin="normal"
              />

              <TextField
                label="Other"
                name="other"
                value={input.other}
                onChange={(e) => handleInputChange(e)}
                margin="normal"
              />
              <Button type="submit" variant="contained" color="primary">
                {update ? "Update" : "Add"}
              </Button>
            </form>
          </div>
        </Modal>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity}>
            {message}
          </Alert>
        </Snackbar>
      </Grid>
    </Grid>
  );
};

export default AddCategoryForm;
